__turbopack_context__.v({
  "checkboxContainer": "ProLeadForm-module-scss-module__js0zoq__checkboxContainer",
  "divider": "ProLeadForm-module-scss-module__js0zoq__divider",
  "form": "ProLeadForm-module-scss-module__js0zoq__form",
  "formContainer": "ProLeadForm-module-scss-module__js0zoq__formContainer",
  "hide": "ProLeadForm-module-scss-module__js0zoq__hide",
  "hideMobile": "ProLeadForm-module-scss-module__js0zoq__hideMobile",
  "phoneAndSubmitContainer": "ProLeadForm-module-scss-module__js0zoq__phoneAndSubmitContainer",
  "suggestion": "ProLeadForm-module-scss-module__js0zoq__suggestion",
  "textAreaContainer": "ProLeadForm-module-scss-module__js0zoq__textAreaContainer",
});
